export default {
  meta: {
    title: 'ppt'
  }
};
